export enum TColorVariants {
  Primary = "primary",
  Secondary = "secondary",
  Active = "active",
  Success = "success",
  Warning = "warning",
  Danger = "danger",
  Error = "error",
  Info = "info",
  Disabled = "disabled",
  None = "",
}
